import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import { FormattedAdoverlayType } from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import { Duration, MrtTable } from '@mi-front/ui';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import { LDate } from '../../../../../../components/date/LDate';
import { LTime } from '../../../../../../components/date/LTime';
import { RowAction } from '../../../../../../components/table/RowAction';
import { RowActions } from '../../../../../../components/table/RowActions';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { AdOverlayListing } from './types';

import { Seconds } from '@mi-front/core';
import { MRT_SortingState } from 'material-react-table';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import SortContext from '../../context';
export const AdOverlayList = (p: ReportResultProps<AdOverlayListing>) => {
  const { $t } = useIntl();
  const station = useActiveStation();
  const { formatMessage } = useIntl();
  const { sort, setSort } = useContext(SortContext);
  const showOnStreamUrlFn = (adoverlay: FormattedAdoverlayType) =>
    buildLoggerStreamUrl(station.slug, {
      selection: {
        from: adoverlay.start_timestamp,
        to: adoverlay.end_timestamp,
      },
      tab: 'adoverlay',
    });
  return (
    <MrtTable
      enableFilters={false}
      manualSorting={true}
      onSortingChange={(s) =>
        setSort(s ? (s as MRT_SortingState) : ([{ id: 'date', desc: false }] as MRT_SortingState))
      }
      columns={[
        {
          id: 'date',
          header: formatMessage({
            id: 'search.dateTime',
            defaultMessage: 'Fecha y hora',
          }),
          enableColumnFilter: false,
          accessorFn: (row) => row.date,
          Cell: ({ row: { original } }) => (
            <div style={{ display: 'flex', gap: '0.375rem' }}>
              <LDate value={original.date} day="2-digit" month="2-digit" year="2-digit" />
              <LTime value={original.date} second={'numeric'} />
            </div>
          ),
          enableSorting: true,
          size: 50,
        },
        {
          id: 'brand',
          enableGlobalFilter: true,
          enableSorting: true,
          enableColumnFilter: false,
          accessorFn: (row) => row.brand,
          header: formatMessage({
            id: 'audit.adoverlayScreen.brand',
            defaultMessage: 'Marca',
          }),
          Cell: ({ renderedCellValue }) => <div>{renderedCellValue}</div>,
          size: 50,
        },
        {
          id: 'image',
          header: formatMessage({
            id: 'audit.adoverlayScreen.image',
            defaultMessage: 'Imagen',
          }),
          Cell: ({ row: { original } }) => (
            <div>
              <img
                src={original.image_b64}
                alt={`${original.brand} ad`}
                style={{ maxWidth: '42rem', height: '6rem' }}
              />
            </div>
          ),
          size: 180,
        },
        {
          id: 'duration',
          accessorFn: (row) => row.duration,
          header: formatMessage({
            id: 'audit.adoverlayScreen.duration',
            defaultMessage: 'Duración',
          }),
          Cell: ({ row: { original } }) => (
            <div>
              <Duration seconds={original.duration as Seconds} />
            </div>
          ),
          enableSorting: true,
          size: 30,
        },

        {
          id: 'actions',
          enableSorting: false,
          accessorFn: () => '',
          header: $t({
            id: 'common.text.actions',
            defaultMessage: 'Acciones',
          }),
          Cell: ({ row }) => (
            <RowActions>
              <RowAction
                title={
                  <FormattedMessage
                    id="audit.matchesScreen.showOnStreamBtn"
                    defaultMessage="Mostrar en stream"
                  />
                }
                link={showOnStreamUrlFn(row.original)}
                icon={<OpenInNewIcon />}
              />
            </RowActions>
          ),
          size: 30,
        },
      ]}
      data={p.result.results}
      state={{
        sorting: sort,
      }}
    />
  );
};
